import { ButtonGroup, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Stack)``;

export const ButtonWrapper = styled(ButtonGroup)`
  color: ${(p) => p.theme.palette.common.black};
  border-color: ${(p) => p.theme.palette.common.black};
  .MuiButton-outlinedSizeMedium {
    border: 1px solid ${(p) => p.theme.palette.common.black};
  }
`;
